import { URLS, URLS_JA } from "@/define";
export function getUrl(val: string) {
  const lang = localStorage.getItem("selectedLanguage") ?? "en";
  if (lang === "en") {
    return URLS[val];
  } else if (lang === "ja") {
    return URLS_JA[val];
  }
}
